import { createAction } from 'redux-actions';

export const initializePrefetch = createAction('INITIALIZE_PREFETCH_NEXT_PAGE');
export const prefetchNextPage = createAction('PREFETCH_NEXT_PAGE');
export const setShouldPrefetchRepeat = createAction('SET_SHOULD_PREFETCH_REPEAT');
